import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { getCustomers, createCustomer, updateCustomer, deleteCustomer, getStores, getUserByPhone, updateUser, getCustomerBodyRecords, getCustomerHabitStats, getCustomerCheckinRecords, getServices, getCustomerRecommendations, createCustomerRecommendation, deleteCustomerRecommendation, getCustomerPurchasedServices, createCustomerPurchasedService, updateCustomerPurchasedServiceStatus, deleteCustomerPurchasedService, getServiceRecords, createServiceRecord, getCustomerBodyComposition, saveCustomerBodyComposition, getCustomer } from '../api';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import Pagination from '../components/Pagination';
import DietaryManagement from '../components/DietaryManagement';

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [storeFilter, setStoreFilter] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [showDetail, setShowDetail] = useState(null);
  const [detailTab, setDetailTab] = useState('body'); // 'body' | 'habit' | 'diet' | 'services'
  const [bodyRecords, setBodyRecords] = useState([]);
  const [habitStats, setHabitStats] = useState({});
  const [bodyComposition, setBodyComposition] = useState(null); // 身体成分数据
  const [nutritionTarget, setNutritionTarget] = useState(null); // 营养目标
  const [editingNutrition, setEditingNutrition] = useState(false); // 编辑营养目标
  const [editingAdvice, setEditingAdvice] = useState(false); // 编辑饮食建议
  const [dietaryAdvice, setDietaryAdvice] = useState({ advice_text: [], restriction_text: [] }); // 饮食建议
  const [dateRange, setDateRange] = useState('7'); // 时间范围（饮食统计）
  const [weightRange, setWeightRange] = useState('month'); // 时间范围（体重记录）：week, month, quarter, year
  const [checkinDateRange, setCheckinDateRange] = useState('week'); // 时间范围（打卡统计）：week, month, custom
  const [dietarySummary, setDietarySummary] = useState(null); // 饮食汇总
  const [dietaryDaily, setDietaryDaily] = useState([]); // 每日饮食记录
  const [expandedIndex, setExpandedIndex] = useState(null); // 展开的记录索引
  const [checkinRecords, setCheckinRecords] = useState({ water: [], sleep: [], exercise: [] });
  const [expandedDates, setExpandedDates] = useState({}); // 控制日期展开状态
  const [showPassword, setShowPassword] = useState(false); // 控制密码显示/隐藏
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [showRecommendModal, setShowRecommendModal] = useState(false);
  const [showDietaryModal, setShowDietaryModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [availableServices, setAvailableServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [recommendOptions, setRecommendOptions] = useState({ priority: 0, notes: '' });
  const [serviceTab, setServiceTab] = useState('recommended'); // 'recommended' | 'available' | 'purchased'
  const [recommendedServices, setRecommendedServices] = useState([]);
  const [purchasedServices, setPurchasedServices] = useState([]); // 已购买服务
  const [showAddPurchasedService, setShowAddPurchasedService] = useState(false); // 添加购买服务弹窗
  const [showServiceDetail, setShowServiceDetail] = useState(null); // 服务详情弹窗
  const [showAddServiceRecord, setShowAddServiceRecord] = useState(false); // 添加服务记录弹窗
  const [serviceRecords, setServiceRecords] = useState([]); // 服务记录列表
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' }); // Toast提示
  const [recommendedPagination, setRecommendedPagination] = useState({ page: 1, pageSize: 10, total: 0, totalPages: 0 });
  const [pagination, setPagination] = useState({ page: 1, pageSize: 20, total: 0, totalPages: 0 });
  const [sortInfo, setSortInfo] = useState({ field: 'created_at', order: 'desc' });
  const [stores, setStores] = useState([]);
  const [user] = useState(() => JSON.parse(sessionStorage.getItem('health_user') || '{}'));
  const isAdmin = user?.role === 'admin';
  const [formData, setFormData] = useState({
    name: '', gender: '', age: '', phone: '',
    weight: '', target_weight: '', height: '',
    nutritionist: '', nutritionist_phone: '', health_status: '', address: '', store_id: '', password: '123456'
  });
  const fileInputRef = useRef(null);

  // 显示Toast提示
  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 3000);
  };

  useEffect(() => { fetchData(); fetchStores(); }, [searchText, pagination.page, pagination.pageSize, sortInfo, storeFilter]);

  // 保存营养目标
  const saveNutritionTarget = async (target) => {
    try {
      await axios.put('/api/dietary/nutrition-targets/' + showDetail.id, target);
      setNutritionTarget({...nutritionTarget, ...target});
      setEditingNutrition(false);
      alert('营养目标保存成功');
    } catch (e) {
      alert('保存失败：' + e.message);
    }
  };

  // 加载饮食记录
  const loadDietaryRecords = async (customerId, range, customStartDate, customEndDate) => {
    try {
      const today = new Date();
      let startDate, endDate;
      endDate = today.toISOString().split('T')[0];
      if (range === '7') {
        startDate = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      } else if (range === '30') {
        startDate = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      } else if (range === 'custom' && customStartDate && customEndDate) {
        startDate = customStartDate;
        endDate = customEndDate;
      } else {
        startDate = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      }
      const res = await axios.get('/api/dietary-records/' + customerId + '?startDate=' + startDate + '&endDate=' + endDate);
      if (res.data.success) {
        setDietarySummary(res.data.data.summary);
        setDietaryDaily(res.data.data.daily || []);
      }
    } catch (e) {
      console.log('加载饮食记录失败:', e);
    }
  };

  // 加载已购买服务
  const loadPurchasedServices = async (customerId) => {
    try {
      const res = await getCustomerPurchasedServices(customerId);
      if (res.data.success) {
        setPurchasedServices(res.data.data);
      }
    } catch (e) {
      console.log('加载已购买服务失败:', e);
    }
  };

  // 加载服务记录
  const loadServiceRecords = async (purchasedServiceId) => {
    try {
      const res = await getServiceRecords(purchasedServiceId);
      if (res.data.success) {
        setServiceRecords(res.data.data);
      }
    } catch (e) {
      console.log('加载服务记录失败:', e);
    }
  };

  // 更新服务状态
  const updateServiceStatus = async (id, status) => {
    try {
      await updateCustomerPurchasedServiceStatus(id, status);
      showToast(status === 'paused' ? '已暂停' : '已恢复', 'success');
      if (selectedCustomer?.id) loadPurchasedServices(selectedCustomer.id);
    } catch (e) {
      showToast('操作失败', 'error');
    }
  };

  // 删除购买服务
  const deletePurchasedService = async (id) => {
    if (!window.confirm('确定删除该购买服务？')) return;
    try {
      await deleteCustomerPurchasedService(id);
      showToast('删除成功', 'success');
      if (selectedCustomer?.id) loadPurchasedServices(selectedCustomer.id);
    } catch (e) {
      showToast('删除失败', 'error');
    }
  };

  // 切换展开状态
  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  // 客户服务弹窗打开时加载购买服务
  useEffect(() => {
    if (selectedCustomer?.id) {
      loadPurchasedServices(selectedCustomer.id);
    }
  }, [selectedCustomer?.id]);

  // 时间范围变化时重新加载
  useEffect(() => {
    if (showDetail?.id && dateRange) {
      loadDietaryRecords(showDetail.id, dateRange);
    }
  }, [dateRange]);

  // 打卡统计时间范围变化时重新加载
  useEffect(() => {
    if (showDetail?.id && checkinDateRange) {
      loadCheckinRecords(showDetail.id, checkinDateRange);
    }
  }, [checkinDateRange]);

  // 加载打卡记录
  const loadCheckinRecords = async (customerId, range, customStartDate, customEndDate) => {
    try {
      const today = new Date();
      let dateRangeParam = range;
      if (range === 'custom' && customStartDate && customEndDate) {
        dateRangeParam = 'custom';
        const res = await getCustomerCheckinRecords(customerId, dateRangeParam, customStartDate, customEndDate);
        if (res.data.success) setCheckinRecords(res.data.data);
      } else {
        const res = await getCustomerCheckinRecords(customerId, dateRangeParam);
        if (res.data.success) setCheckinRecords(res.data.data);
      }
    } catch (e) { console.error(e); }
  };

  // 加载详情数据 - 优化：默认tab立即加载，其他tab延迟加载
  const loadDetailData = async (customerId) => {
    setLoadingDetail(true);
    try {
      // 同时加载客户最新信息、体型档案和身体成分数据
      const [customerRes, bodyRes, compRes] = await Promise.all([
        getCustomer(customerId),
        getCustomerBodyRecords(customerId, weightRange),
        getCustomerBodyComposition(customerId)
      ]);
      // 更新showDetail中的客户信息（包含最新体重等）
      if (customerRes.data.success) {
        setShowDetail(prev => ({ ...prev, ...customerRes.data.data }));
      }
      if (bodyRes.data.success) setBodyRecords(bodyRes.data.data);
      if (compRes.data.success) setBodyComposition(compRes.data.data);
    } catch (e) { console.error(e); }
    setLoadingDetail(false);

    // 打卡统计延迟加载
    setTimeout(async () => {
      try {
        const [habitRes, checkinRes] = await Promise.all([
          getCustomerHabitStats(customerId),
          getCustomerCheckinRecords(customerId, 'week')
        ]);
        if (habitRes.data.success) setHabitStats(habitRes.data.data);
        if (checkinRes.data.success) setCheckinRecords(checkinRes.data.data);
      } catch (e) { console.error(e); }
    }, 100);

    // 饮食目标和建议延迟加载
    setTimeout(async () => {
      try {
        const [nutritionRes, adviceRes] = await Promise.all([
          axios.get('/api/dietary/nutrition-targets/' + customerId),
          axios.get('/api/advice/' + customerId)
        ]);
        if (nutritionRes.data.success) setNutritionTarget(nutritionRes.data.data);
        if (adviceRes.data.success && adviceRes.data.data) {
          setDietaryAdvice({
            advice_text: adviceRes.data.data.advice_text || [],
            restriction_text: adviceRes.data.data.restriction_text || []
          });
        }
        loadDietaryRecords(customerId, dateRange);
      } catch (e) { console.error(e); }
    }, 200);
  };

  // 监听showDetail变化加载数据
  useEffect(() => {
    if (showDetail?.id) {
      loadDetailData(showDetail.id);
    }
  }, [showDetail?.id]);

  const fetchStores = async () => {
    if (isAdmin) {
      try {
        const res = await getStores();
        if (res.data.success) setStores(res.data.data);
      } catch (e) {}
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await getCustomers({
        search: searchText,
        store_id: storeFilter,
        page: pagination.page,
        pageSize: pagination.pageSize,
        sortBy: sortInfo.field,
        sortOrder: sortInfo.order
      });
      if (res.data.success) {
        setCustomers(res.data.data);
        if (res.data.pagination) {
          setPagination(prev => ({ ...prev, ...res.data.pagination }));
        }
      }
    } catch (error) { console.error(error); }
    finally { setLoading(false); }
  };

  const handlePageChange = (page) => {
    setPagination(prev => ({ ...prev, page }));
  };

  const handlePageSizeChange = (pageSize) => {
    setPagination(prev => ({ ...prev, pageSize, page: 1 }));
  };

  const handleSortChange = (field, order) => {
    setSortInfo({ field, order });
  };

  // 切换日期展开/折叠状态
  const toggleDateExpansion = (date) => {
    setExpandedDates(prev => ({
      ...prev,
      [date]: !prev[date]
    }));
  };

  // 按日期分组打卡记录
  const groupCheckinRecordsByDate = () => {
    const allRecords = [
      ...(checkinRecords.water || []).map(r => ({ ...r, type: 'water' })),
      ...(checkinRecords.sleep || []).map(r => ({ ...r, type: 'sleep' })),
      ...(checkinRecords.exercise || []).map(r => ({ ...r, type: 'exercise' }))
    ];

    // 按日期分组
    const grouped = {};
    allRecords.forEach(record => {
      if (!grouped[record.record_date]) {
        grouped[record.record_date] = [];
      }
      grouped[record.record_date].push(record);
    });

    // 转换为数组并按日期排序
    return Object.entries(grouped)
      .map(([date, records]) => ({ date, records }))
      .sort((a, b) => new Date(b.date) - new Date(a.date))
      .slice(0, 7); // 显示最近7天
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let customerId;
      if (editItem) {
        await updateCustomer(editItem.id, formData);
        customerId = editItem.id;
        // 如有修改密码，同时更新用户密码
        if (formData.password) {
          // 根据手机号查找用户并更新密码
          const userRes = await getUserByPhone(formData.phone);
          if (userRes.data.success && userRes.data.data) {
            await updateUser(userRes.data.id, { password: formData.password, nickname: formData.name, phone: formData.phone });
          }
        }
      } else {
        const res = await createCustomer(formData);
        customerId = res.data?.data?.id;
      }

      // 保存身体成分数据
      if (customerId && (formData.muscle_mass || formData.bone_density || formData.visceral_fat_level || formData.moisture_rate || formData.waist_circumference || formData.chest_circumference || formData.hip_circumference)) {
        await saveCustomerBodyComposition(customerId, {
          muscle_mass: formData.muscle_mass || null,
          bone_density: formData.bone_density || null,
          visceral_fat_level: formData.visceral_fat_level || null,
          moisture_rate: formData.moisture_rate || null,
          waist_circumference: formData.waist_circumference || null,
          chest_circumference: formData.chest_circumference || null,
          hip_circumference: formData.hip_circumference || null
        });
      }

      setShowModal(false);
      resetForm();
      fetchData(searchText);
    } catch (error) {
      alert(error.response?.data?.message || error.message);
    }
  };

  const handleSubmitClick = () => {
    const form = document.getElementById('customer-form');
    if (form.reportValidity && !form.reportValidity()) return;
    handleSubmit({ preventDefault: () => {} });
  };

  const handleEdit = async (item) => {
    setEditItem(item);
    // 获取身体成分数据
    let bodyCompData = {};
    try {
      const compRes = await getCustomerBodyComposition(item.id);
      if (compRes.data.success && compRes.data.data) {
        bodyCompData = compRes.data.data;
      }
    } catch (e) { console.error(e); }

    setFormData({
      name: item.name, gender: item.gender || '', age: item.age || '', phone: item.phone || '',
      weight: item.weight || '', target_weight: item.target_weight || '',
      height: item.height || '', nutritionist: item.nutritionist || '', nutritionist_phone: item.nutritionist_phone || '',
      health_status: item.health_status || '', address: item.address || '', store_id: item.store_id || '', password: '123456',
      muscle_mass: bodyCompData.muscle_mass || '', bone_density: bodyCompData.bone_density || '',
      visceral_fat_level: bodyCompData.visceral_fat_level || '', moisture_rate: bodyCompData.moisture_rate || '',
      waist_circumference: bodyCompData.waist_circumference || '', chest_circumference: bodyCompData.chest_circumference || '', hip_circumference: bodyCompData.hip_circumference || ''
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    // eslint-disable-next-line no-restricted-globals
    if (window.confirm('确定删除?')) {
      try {
        await deleteCustomer(id);
        fetchData(searchText);
      } catch (e) {
        alert(e.response?.data?.message || '删除失败');
      }
    }
  };

  // 服务推荐相关函数
  const handleServiceRecommend = async (customer) => {
    setSelectedCustomer(customer);
    setShowRecommendModal(true);
    setSelectedServices([]);
    setRecommendOptions({ priority: 0, notes: '' });
    setServiceTab('recommended'); // 默认显示已推荐服务标签页

    const currentUser = JSON.parse(sessionStorage.getItem('health_user') || '{}');

    try {
      const [servicesRes, recommendedRes, purchasedRes] = await Promise.all([
        getServices({}),
        getCustomerRecommendations(customer.id),
        getCustomerPurchasedServices(customer.id)
      ]);

      if (purchasedRes.data.success) {
        setPurchasedServices(purchasedRes.data.data);
      }

      if (servicesRes.data.success) {
        // 修复数据类型匹配问题：确保比较时两边都是数字
        const userStoreId = currentUser.storeId ? parseInt(currentUser.storeId) : null;

        const services = currentUser.role === 'admin' || !userStoreId
          ? servicesRes.data.data
          : servicesRes.data.data.filter(s => s.store_id === userStoreId);

        setAvailableServices(services);
      }

      if (recommendedRes.data.success) {
        setRecommendedServices(recommendedRes.data.data);
      }
    } catch (e) {
      console.error('获取服务列表失败', e);
    }
  };

  // 膳食管理
  const handleDietaryManage = (customer) => {
    setSelectedCustomer(customer);
    setShowDietaryModal(true);
  };

  // 加载已推荐服务
  const loadRecommendedServices = async (customerId) => {
    try {
      const res = await getCustomerRecommendations(customerId);
      if (res.data.success) {
        setRecommendedServices(res.data.data);
      }
    } catch (e) {
      console.error('获取已推荐服务失败', e);
    }
  };

  // 删除推荐服务
  const handleDeleteRecommendation = async (serviceId) => {
    if (!window.confirm('确定删除这条推荐吗？')) {
      return;
    }
    try {
      await deleteCustomerRecommendation(selectedCustomer.id, serviceId);
      showToast('✅ 删除成功');
      // 重新加载已推荐服务列表
      await loadRecommendedServices(selectedCustomer.id);
    } catch (e) {
      showToast('❌ 删除失败：' + (e.response?.data?.message || e.message), 'error');
    }
  };

  const toggleServiceSelection = (serviceId) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleSaveRecommendation = async () => {
    if (selectedServices.length === 0) {
      showToast('⚠️ 请至少选择一项服务', 'error');
      return;
    }
    if (!window.confirm(`确定向客户 ${selectedCustomer.name} 推荐 ${selectedServices.length} 个服务吗？`)) {
      return;
    }
    try {
      await createCustomerRecommendation(selectedCustomer.id, {
        service_ids: selectedServices,
        priority: recommendOptions.priority,
        notes: recommendOptions.notes
      });
      showToast(`✅ 成功推荐 ${selectedServices.length} 个服务`);

      // 重新加载已推荐服务
      await loadRecommendedServices(selectedCustomer.id);

      // 清空选择
      setSelectedServices([]);
      setRecommendOptions({ priority: 0, notes: '' });

      // 切换到已推荐服务标签页
      setServiceTab('recommended');
    } catch (e) {
      showToast('❌ 推荐失败：' + (e.response?.data?.message || e.message), 'error');
    }
  };

  const resetForm = () => {
    setEditItem(null);
    setFormData({
      name: '', gender: '', age: '', phone: '',
      weight: '', target_weight: '', height: '',
      nutritionist: '', health_status: '', address: '',
      muscle_mass: '', bone_density: '',
      visceral_fat_level: '', moisture_rate: '',
      waist_circumference: '', chest_circumference: '', hip_circumference: ''
    });
  };

  // 计算BMI
  const calcBMI = (weight, height) => {
    if (!weight || !height) return '-';
    const bmi = weight / Math.pow(height / 100, 2);
    return bmi.toFixed(1);
  };

  // BMI评估
  const getBMIEval = (bmi) => {
    if (bmi === '-') return '-';
    const num = parseFloat(bmi);
    if (num < 18.5) return '偏瘦';
    if (num < 24) return '正常';
    if (num < 28) return '超重';
    return '肥胖';
  };

  // 电话脱敏
  const maskPhone = (phone) => {
    if (!phone) return '-';
    return phone.replace(/(\d{3})\d+(\d{4})/, '$1****$2');
  };

  // 导出客户CSV
  const exportCSV = () => {
    const allData = customers.map((c, i) => {
      const bmi = calcBMI(c.weight, c.height);
      return {
        序号: i + 1,
        姓名: c.name,
        性别: c.gender || '',
        年龄: c.age || '',
        电话: c.phone || '',
        当前体重: c.weight || '',
        目标体重: c.target_weight || '',
        身高: c.height || '',
        BMI: bmi,
        健康顾问: c.nutritionist || '',
        健康顾问电话: c.nutritionist_phone || '',
        健康状态: getBMIEval(bmi),
        地址: c.address || ''
      };
    });

    const headers = Object.keys(allData[0] || {});
    const csv = [headers.join(','), ...allData.map(r => headers.map(h => r[h] || '').join(','))].join('\n');
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `客户_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
  };

  // 导入客户CSV
  const importCSV = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const text = e.target.result;
        const lines = text.split('\n').filter(l => l.trim());
        const headers = lines[0].split(',');

        const imported = [];
        for (let i = 1; i < lines.length; i++) {
          const values = lines[i].split(',');
          if (values.length < 2) continue;

          const row = {};
          headers.forEach((h, idx) => { row[h.trim()] = values[idx]?.trim() || ''; });

          // 映射字段
          const customer = {
            name: row['姓名'],
            gender: row['性别'],
            age: parseInt(row['年龄']) || undefined,
            phone: row['电话'],
            weight: parseFloat(row['当前体重']) || undefined,
            target_weight: parseFloat(row['目标体重']) || undefined,
            height: parseFloat(row['身高']) || undefined,
            nutritionist: row['健康顾问'],
            nutritionist_phone: row['健康顾问电话'] || '',
            address: row['地址']
          };

          if (customer.name) imported.push(customer);
        }

        if (imported.length === 0) {
          alert('未找到有效数据');
          return;
        }

        // eslint-disable-next-line no-restricted-globals
        if (!confirm(`确定导入 ${imported.length} 条客户数据？`)) return;

        // 逐条创建
        let success = 0;
        for (const c of imported) {
          try {
            await createCustomer(c);
            success++;
          } catch (err) { console.error(err); }
        }

        alert(`导入完成，成功 ${success} 条`);
        fetchData(searchText);
      } catch (err) {
        alert('导入失败: ' + err.message);
      }
    };
    reader.readAsText(file, 'utf-8');
    event.target.value = '';
  };

  const getHealthBadge = (status) => {
    const colors = { '正常': '#52c41a', '超重': '#fa8c16', '肥胖': '#f5222d', '偏瘦': '#1890ff' };
    const color = colors[status] || '#999';
    return <span style={{ color, border: `1px solid ${color}`, padding: '2px 8px', borderRadius: '10px', fontSize: '12px' }}>{status || '-'}</span>;
  };

  return (
    <div className="content-card">
      <div className="section-title">客户管理</div>

      <div className="toolbar-row">
        <div className="toolbar-left">
          <input className="search-input" placeholder="搜索客户..." value={searchText} onChange={(e) => setSearchText(e.target.value)} />
          {isAdmin && (
            <select className="filter-select" style={{marginLeft:8}} value={storeFilter} onChange={e => setStoreFilter(e.target.value)}>
              <option value="">全部门店</option>
              {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          )}
        </div>
        <div>
          <button className="action-btn btn-blue" onClick={() => { resetForm(); setShowModal(true); }}>+ 新增客户</button>
        </div>
      </div>

      {loading ? <div className="loading-text">加载中...</div> : (
        <>
          <table className="basic-table">
            <thead>
              <tr>
                <th className="no-cell">序号</th>
                <th onClick={() => handleSortChange('name', sortInfo.field === 'name' ? (sortInfo.order === 'asc' ? 'desc' : 'asc') : 'asc')} style={{cursor:'pointer'}}>
                  姓名{sortInfo.field==='name' && <span>{sortInfo.order==='asc'?'↑':'↓'}</span>}
                </th>
                <th>性别</th><th>年龄</th><th>电话</th><th>门店</th>
                <th onClick={() => handleSortChange('weight', sortInfo.field === 'weight' ? (sortInfo.order === 'asc' ? 'desc' : 'asc') : 'asc')} style={{cursor:'pointer'}}>
                  体重{sortInfo.field==='weight' && <span>{sortInfo.order==='asc'?'↑':'↓'}</span>}
                </th>
                <th>目标体重</th><th>身高</th><th>BMI</th><th>健康顾问</th><th>健康顾问电话</th><th>健康</th><th>操作</th>
              </tr>
            </thead>
            <tbody>
              {customers.length > 0 ? customers.map((c, i) => {
                const bmi = calcBMI(c.weight, c.height);
                return (
                  <tr key={c.id}>
                    <td className="no-cell">{i + 1}</td>
                    <td>{c.name}</td>
                    <td>{c.gender || '-'}</td>
                    <td>{c.age || '-'}</td>
                    <td>{maskPhone(c.phone)}</td>
                    <td>{c.store_name || '-'}</td>
                    <td>{c.weight ? c.weight + 'kg' : '-'}</td>
                    <td>{c.target_weight ? c.target_weight + 'kg' : '-'}</td>
                    <td>{c.height ? c.height + 'cm' : '-'}</td>
                    <td>{bmi}</td>
                    <td>{c.nutritionist || '-'}</td>
                    <td>{c.nutritionist_phone || '-'}</td>
                    <td>{getHealthBadge(getBMIEval(bmi))}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button className="btn-xs btn-gray" onClick={() => setShowDetail(c)}>详情</button>
                        <button className="btn-xs btn-green" onClick={() => handleServiceRecommend(c)}>客户服务</button>
                        <button className="btn-xs btn-orange" onClick={() => handleDietaryManage(c)}>膳食管理</button>
                        <button className="btn-xs btn-blue" onClick={() => handleEdit(c)}>编辑</button>
                        <button className="btn-xs btn-red" onClick={() => handleDelete(c.id)}>删除</button>
                      </div>
                    </td>
                  </tr>
                );
              }) : (
                <tr><td colSpan="12" style={{ textAlign: 'center', color: '#999' }}>暂无数据</td></tr>
              )}
            </tbody>
          </table>

          <Pagination
            pagination={pagination}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </>
      )}

      {showModal && (
        <div className="modal-mask">
          <div className="modal-box modal-wide" onClick={e => e.stopPropagation()}>
            <div className="modal-title">
              <span>{editItem ? '编辑客户' : '新增客户'}</span>
              <span className="modal-close" onClick={() => setShowModal(false)}>×</span>
            </div>
            <form id="customer-form" onSubmit={handleSubmit}>
              <div className="modal-content">
                {isAdmin && (
                  <div className="form-row">
                    <div className="form-field">
                      <label className="form-label">所属门店 *</label>
                      <select className="form-input" value={formData.store_id} onChange={e => setFormData({...formData, store_id: e.target.value})} required>
                        <option value="">请选择门店</option>
                        {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                      </select>
                    </div>
                  </div>
                )}
                <div className="form-tip">带 <span style={{color:'#ff4d4f'}}>*</span> 号的为必填项</div>
                <div className="form-section-title">基本信息</div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">姓名 *</label>
                    <input className="form-input" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} required />
                  </div>
                  <div className="form-field">
                    <label className="form-label">性别 *</label>
                    <select className="form-input" value={formData.gender} onChange={e => setFormData({...formData, gender: e.target.value})} required>
                      <option value="">请选择</option><option value="男">男</option><option value="女">女</option>
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">年龄</label>
                    <input className="form-input" type="number" value={formData.age} onChange={e => setFormData({...formData, age: e.target.value})} />
                  </div>
                  <div className="form-field">
                    <label className="form-label">电话 *</label>
                    <input className="form-input" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} required />
                  </div>
                  <div className="form-field">
                    <label className="form-label">密码</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        className="form-input"
                        type={showPassword ? 'text' : 'password'}
                        value={formData.password}
                        onChange={e => setFormData({...formData, password: e.target.value})}
                        style={{ paddingRight: '50px' }}
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          fontSize: '12px',
                          userSelect: 'none',
                          color: '#1890ff',
                          background: '#f0f0f0',
                          padding: '4px 8px',
                          borderRadius: '3px',
                          fontWeight: '500'
                        }}
                        title={showPassword ? '隐藏密码' : '显示密码'}
                        onMouseEnter={(e) => e.target.style.background = '#e6e6e6'}
                        onMouseLeave={(e) => e.target.style.background = '#f0f0f0'}
                      >
                        {showPassword ? '隐藏' : '显示'}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field" style={{ flex: 2 }}>
                    <label className="form-label">地址</label>
                    <input className="form-input" value={formData.address} onChange={e => setFormData({...formData, address: e.target.value})} />
                  </div>
                </div>

                <div className="form-section-title">体重管理</div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">当前体重(kg)</label>
                    <input className="form-input" type="number" step="0.1" value={formData.weight} onChange={e => setFormData({...formData, weight: e.target.value})} />
                  </div>
                  <div className="form-field">
                    <label className="form-label">目标体重(kg)</label>
                    <input className="form-input" type="number" step="0.1" value={formData.target_weight} onChange={e => setFormData({...formData, target_weight: e.target.value})} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">身高(cm)</label>
                    <input className="form-input" type="number" value={formData.height} onChange={e => setFormData({...formData, height: e.target.value})} />
                  </div>
                </div>

                {/* 身体成分 */}
                <div className="form-section-title" style={{marginTop: '12px'}}>身体成分</div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">肌肉量(kg)</label>
                    <input className="form-input" type="number" step="0.1" value={formData.muscle_mass || ''} onChange={e => setFormData({...formData, muscle_mass: e.target.value})} placeholder="如：35.5" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">骨密度T值</label>
                    <input className="form-input" type="number" step="0.1" value={formData.bone_density || ''} onChange={e => setFormData({...formData, bone_density: e.target.value})} placeholder="如：1.2" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">内脏脂肪等级(1-14)</label>
                    <input className="form-input" type="number" value={formData.visceral_fat_level || ''} onChange={e => setFormData({...formData, visceral_fat_level: e.target.value})} placeholder="如：5" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">水分率(%)</label>
                    <input className="form-input" type="number" step="0.1" value={formData.moisture_rate || ''} onChange={e => setFormData({...formData, moisture_rate: e.target.value})} placeholder="如：58.5" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">腰围(cm)</label>
                    <input className="form-input" type="number" value={formData.waist_circumference || ''} onChange={e => setFormData({...formData, waist_circumference: e.target.value})} placeholder="如：80" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">胸围(cm)</label>
                    <input className="form-input" type="number" value={formData.chest_circumference || ''} onChange={e => setFormData({...formData, chest_circumference: e.target.value})} placeholder="如：95" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">臀围(cm)</label>
                    <input className="form-input" type="number" value={formData.hip_circumference || ''} onChange={e => setFormData({...formData, hip_circumference: e.target.value})} placeholder="如：95" />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">健康顾问</label>
                    <input className="form-input" value={formData.nutritionist} onChange={e => setFormData({...formData, nutritionist: e.target.value})} placeholder="负责的健康顾问" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">健康顾问电话</label>
                    <input className="form-input" value={formData.nutritionist_phone} onChange={e => setFormData({...formData, nutritionist_phone: e.target.value})} placeholder="健康顾问电话" />
                  </div>
                </div>
              </div>
              <div className="modal-foot">
                <button type="button" className="action-btn btn-gray" style={{ marginRight: 12 }} onClick={() => setShowModal(false)}>取消</button>
                <button type="button" className="action-btn btn-blue" onClick={handleSubmitClick}>保存</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* 客户详情弹窗 */}
      {showDetail && (
        <div className="modal-mask">
          <div className="modal-box modal-wide" onClick={e => e.stopPropagation()}>
            <div className="modal-title">
              <span>客户健康档案</span>
              <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
                <div style={{fontSize:'12px',color:'#999'}}>
                  <span>健康顾问：{showDetail.nutritionist || '-'}</span>
                  {showDetail.nutritionist_phone && <span style={{marginLeft:'8px'}}>电话：{showDetail.nutritionist_phone}</span>}
                  <span style={{marginLeft:'12px'}}>注册：{showDetail.created_at ? showDetail.created_at.substring(0, 10) : '-'}</span>
                </div>
                <span className="modal-close" onClick={() => setShowDetail(null)}>×</span>
              </div>
            </div>

            {/* Tab切换 */}
            <div className="detail-tabs">
              <div className={`detail-tab ${detailTab === 'body' ? 'active' : ''}`} onClick={() => setDetailTab('body')}>体型档案</div>
              <div className={`detail-tab ${detailTab === 'habit' ? 'active' : ''}`} onClick={() => { console.log('DEBUG: Click habit tab'); setDetailTab('habit'); }}>打卡统计</div>
              <div className={`detail-tab ${detailTab === 'diet' ? 'active' : ''}`} onClick={() => { console.log('DEBUG: Click diet tab'); setDetailTab('diet'); }}>饮食统计</div>
            </div>

            {loadingDetail ? (
              <div className="loading-text" style={{padding: 40, textAlign: 'center'}}>加载中...</div>
            ) : detailTab === 'body' ? (
            <div className="modal-content" style={{minHeight: '300px'}}>
              {/* 基本信息优化 - 紧凑卡片布局 */}
              <div className="detail-section">
                <div className="detail-section-title">👤 基本信息</div>
                <div className="detail-grid" style={{marginBottom: '12px'}}>
                  <div className="detail-item" style={{minWidth: '120px'}}>
                    <span className="detail-label" style={{color: '#666',fontSize: '12px'}}>姓名</span>
                    <span className="detail-value" style={{color: '#333',fontSize: '14px',fontWeight: '500'}}>{showDetail.name}</span>
                  </div>
                  <div className="detail-item" style={{minWidth: '80px'}}>
                    <span className="detail-label" style={{color: '#666',fontSize: '12px'}}>性别</span>
                    <span className="detail-value" style={{color: '#333',fontSize: '14px'}}>{showDetail.gender || '-'}</span>
                  </div>
                  <div className="detail-item" style={{minWidth: '80px'}}>
                    <span className="detail-label" style={{color: '#666',fontSize: '12px'}}>年龄</span>
                    <span className="detail-value" style={{color: '#333',fontSize: '14px'}}>{showDetail.age || '-'}</span>
                  </div>
                  <div className="detail-item" style={{minWidth: '120px'}}>
                    <span className="detail-label" style={{color: '#666',fontSize: '12px'}}>电话</span>
                    <span className="detail-value" style={{color: '#333',fontSize: '14px'}}>{maskPhone(showDetail.phone)}</span>
                  </div>
                </div>
                <div className="detail-row" style={{padding: '6px 0',borderTop: '1px solid #f0f0f0',marginTop: '8px'}}>
                  <span className="detail-label" style={{color: '#999',fontSize: '12px'}}>📍</span>
                  <span className="detail-value" style={{color: '#666',fontSize: '13px'}}>{showDetail.address || '-'}</span>
                </div>
                <div className="detail-grid" style={{marginTop: '8px'}}>
                  <div className="detail-item" style={{minWidth: '100px'}}>
                    <span className="detail-label" style={{color: '#666',fontSize: '12px'}}>📏 身高</span>
                    <span className="detail-value" style={{color: '#333',fontSize: '14px'}}>{showDetail.height || '-'} cm</span>
                  </div>
                  <div className="detail-item" style={{minWidth: '100px'}}>
                    <span className="detail-label" style={{color: '#666',fontSize: '12px'}}>⚖️ 当前</span>
                    <span className="detail-value" style={{color: '#f5222d',fontSize: '15px',fontWeight: '600'}}>{showDetail.weight || '-'} kg</span>
                  </div>
                  <div className="detail-item" style={{minWidth: '100px'}}>
                    <span className="detail-label" style={{color: '#666',fontSize: '12px'}}>🎯 目标</span>
                    <span className="detail-value" style={{color: '#52c41a',fontSize: '15px',fontWeight: '600'}}>{showDetail.target_weight || '-'} kg</span>
                  </div>
                  <div className="detail-item" style={{minWidth: '100px'}}>
                    <span className="detail-label" style={{color: '#666',fontSize: '12px'}}>🔥 代谢</span>
                    <span className="detail-value" style={{color: '#333',fontSize: '14px'}}>{bodyRecords[0]?.basal_metabolism || '-'}</span>
                  </div>
                </div>
              </div>

              {/* 身体成分区块 */}
              {bodyComposition && (
                <div className="detail-section" style={{marginTop: '12px', padding: '12px', background: '#fafafa', borderRadius: '8px'}}>
                  <div className="detail-section-title" style={{marginBottom: '12px'}}>🧍 身体成分</div>

                  {/* 健康评分 */}
                  <div style={{textAlign: 'center', marginBottom: '16px'}}>
                    <div style={{fontSize: '12px', color: '#666', marginBottom: '4px'}}>🏆 健康评分</div>
                    <div style={{display: 'inline-block', padding: '8px 24px', background: bodyComposition.health_score_color || '#1890ff', borderRadius: '8px'}}>
                      <span style={{fontSize: '24px', fontWeight: 'bold', color: '#fff'}}>{bodyComposition.health_score || '-'}</span>
                      <span style={{fontSize: '12px', color: '#fff', marginLeft: '8px'}}>{bodyComposition.health_score_level || ''}</span>
                    </div>
                  </div>

                  {/* 身体成分指标 */}
                  <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px'}}>
                    {/* 肌肉量 */}
                    <div style={{flex: '1 1 45%', minWidth: '100px', padding: '8px', background: '#fff', borderRadius: '6px', textAlign: 'center'}}>
                      <div style={{fontSize: '12px', color: '#999'}}>💪 肌肉量</div>
                      <div style={{fontSize: '14px', fontWeight: '500', color: bodyComposition.muscle_mass_color || '#333'}}>{bodyComposition.muscle_mass || '-'}{bodyComposition.muscle_mass ? 'kg' : ''}</div>
                      <div style={{fontSize: '11px', color: bodyComposition.muscle_mass_color || '#999'}}>{bodyComposition.muscle_mass_level || '-'}</div>
                    </div>

                    {/* 骨密度 */}
                    <div style={{flex: '1 1 45%', minWidth: '100px', padding: '8px', background: '#fff', borderRadius: '6px', textAlign: 'center'}}>
                      <div style={{fontSize: '12px', color: '#999'}}>🦴 骨密度</div>
                      <div style={{fontSize: '14px', fontWeight: '500', color: bodyComposition.bone_density_color || '#333'}}>{bodyComposition.bone_density || '-'}</div>
                      <div style={{fontSize: '11px', color: bodyComposition.bone_density_color || '#999'}}>{bodyComposition.bone_density_level || '-'}</div>
                    </div>

                    {/* 内脏脂肪 */}
                    <div style={{flex: '1 1 45%', minWidth: '100px', padding: '8px', background: '#fff', borderRadius: '6px', textAlign: 'center'}}>
                      <div style={{fontSize: '12px', color: '#999'}}>🔴 内脏脂肪</div>
                      <div style={{fontSize: '14px', fontWeight: '500', color: bodyComposition.visceral_fat_level_color || '#333'}}>{bodyComposition.visceral_fat_level || '-'}</div>
                      <div style={{fontSize: '11px', color: bodyComposition.visceral_fat_level_color || '#999'}}>{bodyComposition.visceral_fat_level_level || '-'}</div>
                    </div>

                    {/* 水分率 */}
                    <div style={{flex: '1 1 45%', minWidth: '100px', padding: '8px', background: '#fff', borderRadius: '6px', textAlign: 'center'}}>
                      <div style={{fontSize: '12px', color: '#999'}}>💦 水分率</div>
                      <div style={{fontSize: '14px', fontWeight: '500', color: bodyComposition.moisture_rate_color || '#333'}}>{bodyComposition.moisture_rate || '-'}{bodyComposition.moisture_rate ? '%' : ''}</div>
                      <div style={{fontSize: '11px', color: bodyComposition.moisture_rate_color || '#999'}}>{bodyComposition.moisture_rate_level || '-'}</div>
                    </div>

                    {/* 三围比例 */}
                    <div style={{flex: '1 1 45%', minWidth: '100px', padding: '8px', background: '#fff', borderRadius: '6px', textAlign: 'center'}}>
                      <div style={{fontSize: '12px', color: '#999'}}>📐 三围比例</div>
                      <div style={{fontSize: '14px', fontWeight: '500', color: bodyComposition.body_measurement_color || '#333'}}>{bodyComposition.body_measurement_ratio || '-'}</div>
                      <div style={{fontSize: '11px', color: bodyComposition.body_measurement_color || '#999'}}>{bodyComposition.body_measurement_level || '-'}</div>
                    </div>
                  </div>
                </div>
              )}

              {/* 体重记录优化 - 趋势图 + 汇总 */}
              <div className="detail-section">
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
                  <div className="detail-section-title">📈 体重记录</div>
                  <select
                    value={weightRange}
                    onChange={async (e) => {
                      const newRange = e.target.value;
                      setWeightRange(newRange);
                      // 重新加载体重记录
                      try {
                        const res = await getCustomerBodyRecords(showDetail.id, newRange);
                        if (res.data.success) setBodyRecords(res.data.data);
                      } catch (err) { console.error(err); }
                    }}
                    style={{padding:'4px 8px',borderRadius:'4px',border:'1px solid #d9d9d9',fontSize:'12px'}}
                  >
                    <option value="week">最近一周</option>
                    <option value="month">最近一月</option>
                    <option value="quarter">最近三月</option>
                    <option value="year">最近一年</option>
                  </select>
                </div>
                {bodyRecords.length > 0 ? (() => {
                  // 计算汇总数据
                  const initialWeight = showDetail.initial_weight || bodyRecords[bodyRecords.length - 1]?.weight;
                  const currentWeight = showDetail.weight || bodyRecords[0]?.weight;
                  const targetWeight = showDetail.target_weight || bodyRecords[0]?.target_weight;
                  const lostWeight = initialWeight && currentWeight ? (initialWeight - currentWeight).toFixed(1) : 0;
                  const totalNeed = initialWeight && targetWeight ? (initialWeight - targetWeight).toFixed(1) : 0;
                  const progress = totalNeed > 0 ? Math.round((lostWeight / totalNeed) * 100) : 0;
                  const remaining = currentWeight && targetWeight ? (currentWeight - targetWeight).toFixed(1) : 0;

                  // 准备图表数据（倒序，最新的在最后）
                  const chartData = [...bodyRecords].reverse().map(r => ({
                    date: r.record_date?.slice(5, 10) || '-',
                    weight: r.weight,
                    target: r.target_weight || targetWeight
                  }));


                  return (
                    <div>
                      {/* 汇总卡片 */}
                      <div className="detail-grid" style={{marginBottom: '16px', gap: '12px'}}>
                        <div className="stat-box" style={{background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: '8px', padding: '12px', textAlign: 'center', flex: 1}}>
                          <div style={{color: '#666', fontSize: '12px', marginBottom: '4px'}}>起始体重</div>
                          <div style={{color: '#666', fontSize: '20px', fontWeight: '600'}}>{initialWeight}kg</div>
                        </div>
                        <div className="stat-box" style={{background: '#fff1f0', border: '1px solid #ffccc7', borderRadius: '8px', padding: '12px', textAlign: 'center', flex: 1}}>
                          <div style={{color: '#cf1322', fontSize: '12px', marginBottom: '4px'}}>已减体重</div>
                          <div style={{color: '#cf1322', fontSize: '20px', fontWeight: '600'}}>{lostWeight}kg</div>
                        </div>
                        <div className="stat-box" style={{background: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: '8px', padding: '12px', textAlign: 'center', flex: 1}}>
                          <div style={{color: '#1890ff', fontSize: '12px', marginBottom: '4px'}}>目标进度</div>
                          <div style={{color: '#1890ff', fontSize: '20px', fontWeight: '600'}}>{progress}%</div>
                        </div>
                        <div className="stat-box" style={{background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: '8px', padding: '12px', textAlign: 'center', flex: 1}}>
                          <div style={{color: '#52c41a', fontSize: '12px', marginBottom: '4px'}}>剩余</div>
                          <div style={{color: '#52c41a', fontSize: '20px', fontWeight: '600'}}>{remaining}kg</div>
                        </div>
                      </div>

                      {/* 体重趋势图 */}
                      <div style={{width: '100%', height: '200px', marginTop: '12px'}}>
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart data={chartData} margin={{top: 5, right: 20, left: 0, bottom: 5}}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                            <XAxis dataKey="date" tick={{fontSize: 11}} stroke="#999" />
                            <YAxis domain={['dataMin - 2', 'dataMax + 2']} tick={{fontSize: 11}} stroke="#999" />
                            <Tooltip
                              contentStyle={{fontSize: '12px'}}
                              formatter={(value) => [`${value}kg`, '体重']}
                            />
                            <ReferenceLine y={targetWeight} stroke="#52c41a" strokeDasharray="5 5" label={{value: '目标', position: 'right', fontSize: 10, fill: '#52c41a'}} />
                            <Line type="monotone" dataKey="weight" stroke="#1890ff" strokeWidth={2} dot={{fill: '#1890ff', r: 4}} activeDot={{r: 6}} />
                            <Line type="monotone" dataKey="target" stroke="#52c41a" strokeWidth={1} strokeDasharray="5 5" dot={false} />
                          </LineChart>
                        </ResponsiveContainer>
                      </div>

                      {/* 记录表格 */}
                      <table className="basic-table" style={{fontSize: '12px', marginTop: '16px'}}>
                        <thead>
                          <tr>
                            <th style={{padding: '6px 8px',background: '#fafafa'}}>日期</th>
                            <th style={{padding: '6px 8px',background: '#fafafa'}}>体重</th>
                            <th style={{padding: '6px 8px',background: '#fafafa'}}>目标</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[...bodyRecords].slice(0, 5).map((r, index) => (
                            <tr key={r.id} style={index === 0 ? {background: '#e6f7ff'} : {}}>
                              <td style={{padding: '6px 8px'}}>{r.record_date?.slice(0, 10) || '-'}</td>
                              <td style={{padding: '6px 8px', fontWeight: index === 0 ? '500' : 'normal'}}>{r.weight}kg</td>
                              <td style={{padding: '6px 8px', color: '#52c41a'}}>{r.target_weight ? r.target_weight + 'kg' : '-'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  );
                })() : (
                  <div style={{color: '#999', padding: 20, textAlign: 'center'}}>暂无记录</div>
                )}
              </div>
            </div>
            ) : detailTab === 'habit' ? (
            <div className="modal-content">

              {/* 时间范围选择 - 独立放在前面 */}
              <div className="detail-section-title" style={{marginBottom: '12px'}}>📋 打卡记录</div>
              <div style={{display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap'}}>
                <button className={`btn-xs ${checkinDateRange === 'week' ? 'btn-blue' : 'btn-gray'}`} onClick={() => setCheckinDateRange('week')}>本周</button>
                <button className={`btn-xs ${checkinDateRange === 'month' ? 'btn-blue' : 'btn-gray'}`} onClick={() => setCheckinDateRange('month')}>本月</button>
                <button className={`btn-xs ${checkinDateRange === 'custom' ? 'btn-blue' : 'btn-gray'}`} onClick={() => setCheckinDateRange('custom')}>自定义</button>
              </div>
              {checkinDateRange === 'custom' && (
                <div style={{display: 'flex', gap: '8px', marginBottom: '12px'}}>
                  <input type="date" className="form-input" style={{flex: 1}} id="customCheckinStartDate" defaultValue="" />
                  <input type="date" className="form-input" style={{flex: 1}} id="customCheckinEndDate" defaultValue="" />
                  <button className="btn-xs btn-blue" onClick={() => {
                    const startDate = document.getElementById('customCheckinStartDate').value;
                    const endDate = document.getElementById('customCheckinEndDate').value;
                    if (startDate && endDate && showDetail?.id) {
                      loadCheckinRecords(showDetail.id, 'custom', startDate, endDate);
                    }
                  }}>查询</button>
                </div>
              )}

              {/* 打卡汇总卡片 */}
              <div className="stats-row" style={{gap: '12px', marginBottom: '12px'}}>
                <div className="stat-box" style={{flex: 1, textAlign: 'center', padding: '12px', background: checkinRecords.water?.length > 0 ? '#f6ffed' : '#fff7e6', borderColor: checkinRecords.water?.length > 0 ? '#b7eb8f' : '#ffd591'}}>
                  <div style={{fontSize: '14px', fontWeight: '500'}}>💧 喝水</div>
                  <div style={{fontSize: '20px', fontWeight: 'bold', color: '#1890ff'}}>{checkinRecords.water?.length || 0}<span style={{fontSize: '12px', fontWeight: 'normal'}}>次</span></div>
                  <div style={{fontSize: '12px', color: '#999'}}>{checkinRecords.water?.reduce((sum, w) => sum + w.amount, 0) || 0}ml</div>
                </div>
                <div className="stat-box" style={{flex: 1, textAlign: 'center', padding: '12px', background: checkinRecords.sleep?.length > 0 ? '#f6ffed' : '#fff7e6', borderColor: checkinRecords.sleep?.length > 0 ? '#b7eb8f' : '#ffd591'}}>
                  <div style={{fontSize: '14px', fontWeight: '500'}}>😴 睡眠</div>
                  <div style={{fontSize: '20px', fontWeight: 'bold', color: '#722ed1'}}>{checkinRecords.sleep?.length || 0}<span style={{fontSize: '12px', fontWeight: 'normal'}}>次</span></div>
                  <div style={{fontSize: '12px', color: '#999'}}>{checkinRecords.exercise?.length || 0}条记录</div>
                </div>
                <div className="stat-box" style={{flex: 1, textAlign: 'center', padding: '12px', background: checkinRecords.exercise?.length > 0 ? '#f6ffed' : '#fff7e6', borderColor: checkinRecords.exercise?.length > 0 ? '#b7eb8f' : '#ffd591'}}>
                  <div style={{fontSize: '14px', fontWeight: '500'}}>🏃 运动</div>
                  <div style={{fontSize: '20px', fontWeight: 'bold', color: '#52c41a'}}>{checkinRecords.exercise?.length || 0}<span style={{fontSize: '12px', fontWeight: 'normal'}}>次</span></div>
                  <div style={{fontSize: '12px', color: '#999'}}>{checkinRecords.exercise?.reduce((sum, e) => sum + (e.duration || 0), 0) || 0}分钟</div>
                </div>
              </div>

              {/* 喝水详细统计 */}
              <div className="detail-section">
                <div className="detail-section-title" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span>💧 喝水统计 {checkinDateRange === 'week' ? '(本周)' : checkinDateRange === 'month' ? '(本月)' : '(自定义)'}</span>
                </div>
                {checkinRecords.water?.length > 0 ? (
                  <div className="stats-row" style={{gap: '12px'}}>
                    <div className="stat-box" style={{
                      background: 'linear-gradient(135deg, #e6f7ff, #bae7ff)',
                      border: '1px solid #91d5ff',
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      flex: '1',
                      minWidth: '100px'
                    }}>
                      <div className="stat-label" style={{color: '#0050b3',fontSize: '12px',marginBottom: '8px'}}>打卡次数</div>
                      <div className="stat-value" style={{color: '#1890ff',fontSize: '24px',fontWeight: '600'}}>{checkinRecords.water.length}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>次</span></div>
                    </div>
                    <div className="stat-box" style={{
                      background: 'linear-gradient(135deg, #e6f7ff, #bae7ff)',
                      border: '1px solid #91d5ff',
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      flex: '1',
                      minWidth: '100px'
                    }}>
                      <div className="stat-label" style={{color: '#0050b3',fontSize: '12px',marginBottom: '8px'}}>总饮水量</div>
                      <div className="stat-value" style={{color: '#1890ff',fontSize: '24px',fontWeight: '600'}}>{checkinRecords.water.reduce((sum, w) => sum + w.amount, 0)}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>ml</span></div>
                    </div>
                    <div className="stat-box" style={{
                      background: 'linear-gradient(135deg, #e6f7ff, #bae7ff)',
                      border: '1px solid #91d5ff',
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      flex: '1',
                      minWidth: '100px'
                    }}>
                      <div className="stat-label" style={{color: '#0050b3',fontSize: '12px',marginBottom: '8px'}}>平均每次</div>
                      <div className="stat-value" style={{color: '#1890ff',fontSize: '24px',fontWeight: '600'}}>{Math.round(checkinRecords.water.reduce((sum, w) => sum + w.amount, 0) / checkinRecords.water.length)}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>ml</span></div>
                    </div>
                  </div>
                ) : (
                  <div style={{color: '#999', padding: 20, textAlign: 'center'}}>暂无喝水记录</div>
                )}
              </div>

              {/* 睡眠汇总 - 优化版 */}
              <div className="detail-section">
                <div className="detail-section-title">🌙 睡眠统计 (本周)</div>
                {checkinRecords.sleep?.length > 0 ? (
                  <div className="stats-row" style={{gap: '12px'}}>
                    <div className="stat-box" style={{
                      background: 'linear-gradient(135deg, #f9f0ff, #efdbff)',
                      border: '1px solid #d3adf7',
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      flex: '1',
                      minWidth: '100px'
                    }}>
                      <div className="stat-label" style={{color: '#531dab',fontSize: '12px',marginBottom: '8px'}}>睡眠次数</div>
                      <div className="stat-value" style={{color: '#722ed1',fontSize: '24px',fontWeight: '600'}}>{checkinRecords.sleep.length}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>次</span></div>
                    </div>
                    <div className="stat-box" style={{
                      background: 'linear-gradient(135deg, #f9f0ff, #efdbff)',
                      border: '1px solid #d3adf7',
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      flex: '1',
                      minWidth: '100px'
                    }}>
                      <div className="stat-label" style={{color: '#531dab',fontSize: '12px',marginBottom: '8px'}}>总睡眠时长</div>
                      <div className="stat-value" style={{color: '#722ed1',fontSize: '24px',fontWeight: '600'}}>{Math.floor(checkinRecords.sleep.reduce((sum, s) => sum + (parseInt(s.duration) || 0), 0) / 60)}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>h</span></div>
                    </div>
                    <div className="stat-box" style={{
                      background: 'linear-gradient(135deg, #f9f0ff, #efdbff)',
                      border: '1px solid #d3adf7',
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      flex: '1',
                      minWidth: '100px'
                    }}>
                      <div className="stat-label" style={{color: '#531dab',fontSize: '12px',marginBottom: '8px'}}>平均时长</div>
                      <div className="stat-value" style={{color: '#722ed1',fontSize: '24px',fontWeight: '600'}}>{Math.floor(checkinRecords.sleep.reduce((sum, s) => sum + (parseInt(s.duration) || 0), 0) / checkinRecords.sleep.length / 60)}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>h</span>{Math.floor((checkinRecords.sleep.reduce((sum, s) => sum + (parseInt(s.duration) || 0), 0) / checkinRecords.sleep.length) % 60)}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>m</span></div>
                    </div>
                  </div>
                ) : (
                  <div style={{color: '#999', padding: 20, textAlign: 'center'}}>暂无睡眠记录</div>
                )}
              </div>

              {/* 运动汇总 - 优化版 */}
              <div className="detail-section">
                <div className="detail-section-title">🏃 运动统计 (本周)</div>
                {checkinRecords.exercise?.length > 0 ? (
                  <div className="stats-row" style={{gap: '12px'}}>
                    <div className="stat-box" style={{
                      background: 'linear-gradient(135deg, #f6ffed, #d9f7be)',
                      border: '1px solid #b7eb8f',
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      flex: '1',
                      minWidth: '100px'
                    }}>
                      <div className="stat-label" style={{color: '#389e0d',fontSize: '12px',marginBottom: '8px'}}>运动次数</div>
                      <div className="stat-value" style={{color: '#52c41a',fontSize: '24px',fontWeight: '600'}}>{checkinRecords.exercise.length}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>次</span></div>
                    </div>
                    <div className="stat-box" style={{
                      background: 'linear-gradient(135deg, #f6ffed, #d9f7be)',
                      border: '1px solid #b7eb8f',
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      flex: '1',
                      minWidth: '100px'
                    }}>
                      <div className="stat-label" style={{color: '#389e0d',fontSize: '12px',marginBottom: '8px'}}>总运动时长</div>
                      <div className="stat-value" style={{color: '#52c41a',fontSize: '24px',fontWeight: '600'}}>{checkinRecords.exercise.reduce((sum, e) => sum + (parseInt(e.duration) || 0), 0)}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>分钟</span></div>
                    </div>
                    <div className="stat-box" style={{
                      background: 'linear-gradient(135deg, #f6ffed, #d9f7be)',
                      border: '1px solid #b7eb8f',
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      flex: '1',
                      minWidth: '100px'
                    }}>
                      <div className="stat-label" style={{color: '#389e0d',fontSize: '12px',marginBottom: '8px'}}>消耗卡路里</div>
                      <div className="stat-value" style={{color: '#52c41a',fontSize: '24px',fontWeight: '600'}}>{checkinRecords.exercise.reduce((sum, e) => sum + (parseInt(e.calories) || 0), 0)}<span style={{fontSize: '14px',fontWeight: '400',marginLeft: '2px'}}>千卡</span></div>
                    </div>
                  </div>
                ) : (
                  <div style={{color: '#999', padding: 20, textAlign: 'center'}}>暂无运动记录</div>
                )}
              </div>

              {/* 最近打卡记录 */}
              {checkinRecords.water?.length > 0 || checkinRecords.sleep?.length > 0 || checkinRecords.exercise?.length > 0 ? (
                <div className="detail-section">
                  <div className="detail-section-title">📋 最近打卡记录</div>
                  <div className="checkin-list-grouped">
                    {groupCheckinRecordsByDate().map(({ date, records }) => (
                      <div key={date} className="checkin-date-group">
                        {/* 日期头部 - 可点击展开/折叠 */}
                        <div
                          className="checkin-date-header"
                          onClick={() => toggleDateExpansion(date)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px 12px',
                            background: '#f5f5f5',
                            borderRadius: '6px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: expandedDates[date] ? '8px' : '0'
                          }}
                        >
                          <span style={{ fontWeight: '500', color: '#333' }}>{date}</span>
                          <span style={{ fontSize: '12px', color: '#666' }}>
                            {expandedDates[date] ? '▼' : '▶'} {records.length}条记录
                          </span>
                        </div>

                        {/* 该日期的详细记录 - 展开时显示 */}
                        {expandedDates[date] && (
                          <div className="checkin-date-records">
                            {records
                              .sort((a, b) => {
                                // 按时间排序
                                const timeA = a.record_time || a.exercise_time ||
                                  (a.type === 'sleep' ? a.sleep_start : '00:00');
                                const timeB = b.record_time || b.exercise_time ||
                                  (b.type === 'sleep' ? b.sleep_start : '00:00');
                                return new Date(`${date} ${timeB}`) - new Date(`${date} ${timeA}`);
                              })
                              .map((item, i) => (
                                <div key={i} className="checkin-item" style={{
                                  padding: '8px 12px',
                                  borderBottom: '1px solid #f0f0f0',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center'
                                }}>
                                  <span className="checkin-type">
                                    {item.type === 'water' ? `💧喝水 ${item.amount}ml` :
                                     item.type === 'exercise' ? `🏃运动 ${item.duration}分钟` :
                                     item.type === 'sleep' ? `🌙睡眠 ${Math.floor(item.duration/60)}h${item.duration%60}m` :
                                     '未知类型'}
                                  </span>
                                  <span className="checkin-time" style={{
                                    fontSize: '12px',
                                    color: '#999',
                                    marginLeft: 'auto'
                                  }}>
                                    {item.type === 'water' ? (item.record_time || '') :
                                     item.type === 'exercise' ? (item.exercise_time || '') :
                                     item.type === 'sleep' ? `${item.sleep_start}-${item.sleep_end}` :
                                     ''}
                                  </span>
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
			  </div>
            ) : detailTab === 'diet' ? (
			<div className="modal-content">
              <div className="detail-section">
                <div className="detail-section-title">📊 营养目标设置</div>
                {nutritionTarget ? (
                  <div style={{background: '#f9f9f9', padding: '16px', borderRadius: '8px', marginBottom: '16px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px'}}>
                      <div>
                        <div style={{fontSize: '24px', fontWeight: 'bold', color: '#FF8C42'}}>{nutritionTarget.daily_calories}</div>
                        <div style={{fontSize: '12px', color: '#666'}}>每日目标(千卡)</div>
                      </div>
                      <div style={{display: 'flex', gap: '8px'}}>
                        <button className="btn-xs btn-blue" onClick={() => setEditingNutrition(true)}>修改</button>
                        <button className="btn-xs btn-blue" onClick={() => setEditingAdvice(true)}>设置饮食建议</button>
                      </div>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px'}}>
                      <div style={{textAlign: 'center', padding: '8px', background: '#fff', borderRadius: '6px'}}>
                        <div style={{fontSize: '14px', fontWeight: 'bold'}}>{nutritionTarget.carbohydrate_ratio}%</div>
                        <div style={{fontSize: '11px', color: '#999'}}>碳水</div>
                      </div>
                      <div style={{textAlign: 'center', padding: '8px', background: '#fff', borderRadius: '6px'}}>
                        <div style={{fontSize: '14px', fontWeight: 'bold'}}>{nutritionTarget.protein_ratio}%</div>
                        <div style={{fontSize: '11px', color: '#999'}}>蛋白</div>
                      </div>
                      <div style={{textAlign: 'center', padding: '8px', background: '#fff', borderRadius: '6px'}}>
                        <div style={{fontSize: '14px', fontWeight: 'bold'}}>{nutritionTarget.fat_ratio}%</div>
                        <div style={{fontSize: '11px', color: '#999'}}>脂肪</div>
                      </div>
                      <div style={{textAlign: 'center', padding: '8px', background: '#fff', borderRadius: '6px'}}>
                        <div style={{fontSize: '14px', fontWeight: 'bold'}}>{nutritionTarget.fiber_ratio}%</div>
                        <div style={{fontSize: '11px', color: '#999'}}>纤维</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{color: '#999', textAlign: 'center', padding: '20px'}}>暂无营养目标</div>
                )}

                <div className="detail-section-title" style={{marginTop: '20px'}}>📋 饮食记录</div>

                {/* 时间范围选择 */}
                <div style={{display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap'}}>
                  <button
                    className={`btn-xs ${dateRange === '7' ? 'btn-blue' : 'btn-gray'}`}
                    onClick={() => setDateRange('7')}
                  >最近7天</button>
                  <button
                    className={`btn-xs ${dateRange === '30' ? 'btn-blue' : 'btn-gray'}`}
                    onClick={() => setDateRange('30')}
                  >最近30天</button>
                  <button
                    className={`btn-xs ${dateRange === 'custom' ? 'btn-blue' : 'btn-gray'}`}
                    onClick={() => setDateRange('custom')}
                  >自定义</button>
                  {dateRange === 'custom' && (
                    <div style={{display: 'flex', gap: '8px', marginTop: '8px', width: '100%'}}>
                      <input type="date" className="form-input" style={{flex: 1}} id="customStartDate" defaultValue="" />
                      <span style={{padding: '8px'}}>至</span>
                      <input type="date" className="form-input" style={{flex: 1}} id="customEndDate" defaultValue="" />
                      <button className="btn-xs btn-blue" onClick={() => {
                        const startDate = document.getElementById('customStartDate').value;
                        const endDate = document.getElementById('customEndDate').value;
                        if (startDate && endDate && showDetail?.id) {
                          loadDietaryRecords(showDetail.id, 'custom', startDate, endDate);
                        }
                      }}>查询</button>
                    </div>
                  )}
                </div>

                {/* 营养汇总卡片 */}
                {dietarySummary && (
                  <div style={{background: '#f9f9f9', padding: '16px', borderRadius: '8px', marginBottom: '16px'}}>
                    <div style={{fontSize: '14px', fontWeight: 'bold', marginBottom: '12px', color: '#333'}}>
                      饮食统计汇总（{dateRange === '7' ? '近7天' : '近30天'}）
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px'}}>
                      <div style={{textAlign: 'center', padding: '8px', background: '#fff', borderRadius: '6px'}}>
                        <div style={{fontSize: '16px', fontWeight: 'bold', color: '#FF8C42'}}>{dietarySummary.avgCalories || 0}</div>
                        <div style={{fontSize: '11px', color: '#999'}}>平均热量</div>
                      </div>
                      <div style={{textAlign: 'center', padding: '8px', background: '#fff', borderRadius: '6px'}}>
                        <div style={{fontSize: '16px', fontWeight: 'bold'}}>{dietarySummary.avgCarbs || 0}%</div>
                        <div style={{fontSize: '11px', color: '#999'}}>平均碳水</div>
                      </div>
                      <div style={{textAlign: 'center', padding: '8px', background: '#fff', borderRadius: '6px'}}>
                        <div style={{fontSize: '16px', fontWeight: 'bold'}}>{dietarySummary.avgProtein || 0}%</div>
                        <div style={{fontSize: '11px', color: '#999'}}>平均蛋白</div>
                      </div>
                      <div style={{textAlign: 'center', padding: '8px', background: '#fff', borderRadius: '6px'}}>
                        <div style={{fontSize: '16px', fontWeight: 'bold'}}>{dietarySummary.avgFat || 0}%</div>
                        <div style={{fontSize: '11px', color: '#999'}}>平均脂肪</div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 每日记录列表 */}
                {dietaryDaily && dietaryDaily.length > 0 ? (
                  <div>
                    {dietaryDaily.map((day, index) => (
                      <div key={day.date} style={{marginBottom: '8px', background: '#fff', borderRadius: '8px', overflow: 'hidden'}}>
                        <div
                          style={{display: 'flex', alignItems: 'center', padding: '12px', cursor: 'pointer'}}
                          onClick={() => toggleExpand(index)}
                        >
                          <span style={{flex: 1, fontWeight: 'bold', color: '#333'}}>{day.date}</span>
                          <span style={{color: '#FF8C42', marginRight: '8px'}}>{day.calories}千卡</span>
                          <span style={{color: '#999', fontSize: '12px', marginRight: '8px'}}>{day.carbs}% {day.protein}% {day.fat}%</span>
                          <span style={{color: '#666'}}>{expandedIndex === index ? '▼' : '▶'}</span>
                        </div>
                        {expandedIndex === index && (
                          <div style={{padding: '0 12px 12px', borderTop: '1px solid #f5f5f5'}}>
                            {day.meals && day.meals.map((meal, idx) => (
                              <div key={idx} style={{display: 'flex', alignItems: 'center', padding: '8px 0', fontSize: '13px'}}>
                                <span style={{width: '50px', color: '#666'}}>
                                  {meal.type === 'breakfast' ? '早餐' : meal.type === 'lunch' ? '午餐' : meal.type === 'dinner' ? '晚餐' : '加餐'}
                                </span>
                                <span style={{flex: 1, color: '#333'}}>{meal.content} {meal.calories}千卡</span>
                                <span style={{color: '#52c41a', fontSize: '12px'}}>完成度:{meal.completion}%</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{color: '#999', textAlign: 'center', padding: '20px'}}>
                    暂无饮食记录
                  </div>
                )}
              </div>
            </div>
            ) : null}

      {/* 营养目标编辑弹窗 */}
      {editingNutrition && nutritionTarget && (
        <div className="modal-mask" onClick={() => setEditingNutrition(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-title">
              <span>设置营养目标</span>
              <span className="modal-close" onClick={() => setEditingNutrition(false)}>×</span>
            </div>
            <div className="modal-content">
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">每日目标热量(千卡)</label>
                  <input type="number" className="form-input" id="editCalories" defaultValue={nutritionTarget.daily_calories} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">碳水比例(%)</label>
                  <input type="number" className="form-input" id="editCarbs" defaultValue={nutritionTarget.carbohydrate_ratio} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">蛋白质比例(%)</label>
                  <input type="number" className="form-input" id="editProtein" defaultValue={nutritionTarget.protein_ratio} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">脂肪比例(%)</label>
                  <input type="number" className="form-input" id="editFat" defaultValue={nutritionTarget.fat_ratio} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">膳食纤维比例(%)</label>
                  <input type="number" className="form-input" id="editFiber" defaultValue={nutritionTarget.fiber_ratio} />
                </div>
              </div>
            </div>
            <div className="modal-foot">
              <button onClick={() => setEditingNutrition(false)}>取消</button>
              <button className="action-btn btn-blue" onClick={() => {
                const target = {
                  daily_calories: parseInt(document.getElementById('editCalories').value) || 1500,
                  carbohydrate_ratio: parseInt(document.getElementById('editCarbs').value) || 40,
                  protein_ratio: parseInt(document.getElementById('editProtein').value) || 30,
                  fat_ratio: parseInt(document.getElementById('editFat').value) || 15,
                  fiber_ratio: parseInt(document.getElementById('editFiber').value) || 15
                };
                saveNutritionTarget(target);
              }}>保存</button>
            </div>
          </div>
        </div>
      )}
          </div>
        </div>
      )}

      {/* 饮食建议编辑弹窗 */}
      {editingAdvice && (
        <div className="modal-mask" onClick={() => setEditingAdvice(false)}>
          <div className="modal-box modal-lg" onClick={e => e.stopPropagation()}>
            <div className="modal-title">
              <span>设置饮食建议</span>
              <span className="modal-close" onClick={() => setEditingAdvice(false)}>×</span>
            </div>
            <div className="modal-content">
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">饮食建议（每行一条）</label>
                  <textarea className="form-input" style={{height: '100px'}} id="editAdviceText" defaultValue={dietaryAdvice.advice_text?.join('\n') || ''} placeholder="每行一条建议，如：&#10;1. 多吃富含膳食纤维的食物&#10;2. 早餐要吃好" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">饮食禁忌（每行一条）</label>
                  <textarea className="form-input" style={{height: '100px'}} id="editRestrictionText" defaultValue={dietaryAdvice.restriction_text?.join('\n') || ''} placeholder="每行一条禁忌，如：&#10;1. 少吃高糖水果&#10;2. 避免晚8点后进食" />
                </div>
              </div>
            </div>
            <div className="modal-foot">
              <button onClick={() => setEditingAdvice(false)}>取消</button>
              <button className="action-btn btn-blue" onClick={async () => {
                const adviceText = document.getElementById('editAdviceText').value.split('\n').filter(t => t.trim());
                const restrictionText = document.getElementById('editRestrictionText').value.split('\n').filter(t => t.trim());
                try {
                  await axios.post('/api/advice/' + showDetail.id, {
                    advice_text: adviceText,
                    restriction_text: restrictionText
                  });
                  setDietaryAdvice({ advice_text: adviceText, restriction_text: restrictionText });
                  setEditingAdvice(false);
                  alert('饮食建议保存成功');
                } catch (e) {
                  alert('保存失败：' + e.message);
                }
              }}>保存</button>
            </div>
          </div>
        </div>
      )}

      {/* 服务推荐弹窗 */}
      {showRecommendModal && (
        <div className="modal-mask" onClick={() => setShowRecommendModal(false)}>
          <div className="modal-box modal-wide" onClick={e => e.stopPropagation()}>
            <div className="modal-title">
              <span>服务推荐 - {selectedCustomer?.name}</span>
              <span className="modal-close" onClick={() => setShowRecommendModal(false)}>×</span>
            </div>
            <div className="modal-content">
              {/* 标签页切换 */}
              <div className="detail-tabs" style={{ marginBottom: 16 }}>
                <div className={`detail-tab ${serviceTab === 'recommended' ? 'active' : ''}`} onClick={() => setServiceTab('recommended')}>
                  已推荐服务 ({recommendedServices.length})
                </div>
                <div className={`detail-tab ${serviceTab === 'available' ? 'active' : ''}`} onClick={() => setServiceTab('available')}>
                  可推荐服务 ({availableServices.filter(s => !recommendedServices.some(r => r.service_id === s.id)).length})
                </div>
                <div className={`detail-tab ${serviceTab === 'purchased' ? 'active' : ''}`} onClick={() => setServiceTab('purchased')}>
                  已购服务 ({purchasedServices.length})
                </div>
              </div>

              {/* 已推荐服务标签页 */}
              {serviceTab === 'recommended' && (
                <div>
                  {recommendedServices.length === 0 ? (
                    <div className="empty-tip" style={{ textAlign: 'center', padding: '60px 20px', color: '#999', background: '#fafafa', borderRadius: 8 }}>
                      <div style={{ fontSize: 48, marginBottom: 16 }}>📋</div>
                      <div style={{ fontSize: 16, marginBottom: 8, color: '#666' }}>暂无已推荐服务</div>
                      <div style={{ fontSize: 14, marginBottom: 24, color: '#999' }}>还没有为客户推荐任何服务</div>
                      <button
                        className="action-btn btn-blue"
                        onClick={() => setServiceTab('available')}
                        style={{ padding: '8px 16px', fontSize: 14 }}
                      >
                        去推荐服务 →
                      </button>
                    </div>
                  ) : (
                    <div className="recommended-services-list" style={{ maxHeight: 400, overflowY: 'auto' }}>
                      {recommendedServices.map(rec => {
                        const service = availableServices.find(s => s.id === rec.service_id);
                        if (!service) return null;
                        return (
                          <div key={rec.id} style={{ padding: 12, marginBottom: 10, background: '#f5f5f5', borderRadius: 8, border: '1px solid #e0e0e0' }}>
                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                              <div style={{ fontSize: 24, marginRight: 12 }}>{service.icon || '🔬'}</div>
                              <div style={{ flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                                  <div style={{ fontWeight: 'bold', fontSize: 14, marginRight: 6 }}>{service.name}</div>
                                  {(() => {
                                    const priorityConfig = {
                                      0: { label: '常规', color: '#999', bg: '#f0f0f0' },
                                      1: { label: '主推', color: '#d32f2f', bg: '#ffebee' },
                                      2: { label: '活动', color: '#f57c00', bg: '#fff3e0' }
                                    };
                                    const config = priorityConfig[rec.priority] || priorityConfig[0];
                                    return (
                                      <span style={{
                                        fontSize: 10,
                                        padding: '2px 6px',
                                        borderRadius: '10px',
                                        background: config.bg,
                                        color: config.color,
                                        fontWeight: 500
                                      }}>
                                        {config.label}
                                      </span>
                                    );
                                  })()}
                                </div>
                                <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>{service.description}</div>
                                {service.body_types && <div style={{ fontSize: 11, color: '#4caf50', marginBottom: 3 }}>适合：{service.body_types}</div>}
                                <div style={{ fontSize: 10, color: '#999' }}>
                                  <div>推荐时间：{rec.created_at ? new Date(rec.created_at).toLocaleString('zh-CN') : '-'}</div>
                                  {rec.notes && <div>备注：{rec.notes}</div>}
                                </div>
                              </div>
                              <button
                                onClick={() => handleDeleteRecommendation(rec.service_id)}
                                style={{
                                  alignSelf: 'flex-start',
                                  marginTop: 2,
                                  width: '28px',
                                  height: '28px',
                                  borderRadius: '4px',
                                  border: 'none',
                                  background: 'transparent',
                                  cursor: 'pointer',
                                  fontSize: '16px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.2s'
                                }}
                                title="删除此推荐"
                                onMouseEnter={(e) => e.target.style.background = '#ffebee'}
                                onMouseLeave={(e) => e.target.style.background = 'transparent'}
                              >
                                🗑️
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

              {/* 可推荐服务标签页 */}
              {serviceTab === 'available' && (
                <div>
                  <div className="form-tip">为客户选择要推荐的服务</div>
                  <div className="service-selection-area" style={{ maxHeight: 300, overflowY: 'auto', marginBottom: 16 }}>
                    {availableServices.filter(s => !recommendedServices.some(r => r.service_id === s.id)).length === 0 ? (
                      <div className="empty-tip" style={{ textAlign: 'center', padding: '40px 20px', color: '#999', background: '#fafafa', borderRadius: 8 }}>
                        <div style={{ fontSize: 32, marginBottom: 12 }}>✅</div>
                        <div style={{ fontSize: 14, marginBottom: 8, color: '#666' }}>所有服务都已推荐</div>
                        <div style={{ fontSize: 12, color: '#999' }}>该客户已拥有所有可推荐的服务</div>
                      </div>
                    ) : (
                      availableServices
                        .filter(service => !recommendedServices.some(r => r.service_id === service.id))
                        .map(service => (
                          <div key={service.id}
                               className={`service-card ${selectedServices.includes(service.id) ? 'selected' : ''}`}
                               style={{ display: 'flex', alignItems: 'center', padding: 12, marginBottom: 8, background: selectedServices.includes(service.id) ? '#e8f5e9' : '#fafafa', borderRadius: 8, border: selectedServices.includes(service.id) ? '2px solid #4caf50' : '2px solid #f0f0f0', cursor: 'pointer' }}
                               onClick={() => toggleServiceSelection(service.id)}>
                            <div style={{ fontSize: 24, marginRight: 12 }}>{service.icon || '🔬'}</div>
                            <div style={{ flex: 1 }}>
                              <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{service.name}</div>
                              <div style={{ fontSize: 12, color: '#666' }}>{service.description}</div>
                              {service.body_types && <div style={{ fontSize: 12, color: '#4caf50', marginTop: 4 }}>适合：{service.body_types}</div>}
                            </div>
                            <div style={{ width: 24, height: 24, borderRadius: 12, background: selectedServices.includes(service.id) ? '#4caf50' : '#ddd', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 14 }}>
                              {selectedServices.includes(service.id) && '✓'}
                            </div>
                          </div>
                        ))
                    )}
                  </div>
                  {selectedServices.length > 0 && (
                    <div className="selected-services" style={{ marginBottom: 16 }}>
                      <div style={{ fontWeight: 'bold', marginBottom: 8 }}>已选择 {selectedServices.length} 项服务</div>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {selectedServices.map(serviceId => {
                          const service = availableServices.find(s => s.id === serviceId);
                          return (
                            <span key={serviceId} style={{ padding: '4px 12px', background: '#4caf50', color: '#fff', borderRadius: 12, fontSize: 12, display: 'flex', alignItems: 'center', gap: 4 }}>
                              {service?.icon} {service?.name}
                              <span style={{ cursor: 'pointer', marginLeft: 4 }} onClick={(e) => { e.stopPropagation(); toggleServiceSelection(serviceId); }}>×</span>
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  <div className="form-row">
                    <div className="form-field">
                      <label className="form-label">推荐优先级</label>
                      <select className="form-input" value={recommendOptions.priority} onChange={e => setRecommendOptions({...recommendOptions, priority: parseInt(e.target.value)})}>
                        <option value="0">常规款</option>
                        <option value="1">主推款</option>
                        <option value="2">活动款</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <label className="form-label">推荐备注</label>
                      <textarea className="form-input" rows={2} value={recommendOptions.notes} onChange={e => setRecommendOptions({...recommendOptions, notes: e.target.value})} placeholder="记录推荐原因、客户需求等" />
                    </div>
                  </div>
                  <div style={{ marginTop: 16 }}>
                    <button className="action-btn btn-blue" onClick={handleSaveRecommendation} disabled={selectedServices.length === 0} style={{ width: '100%', padding: '12px', fontSize: 16 }}>
                      确定推荐 ({selectedServices.length})
                    </button>
                  </div>
                </div>
              )}

              {/* 已购服务标签页 */}
              {serviceTab === 'purchased' && (
                <div>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12}}>
                    <span style={{fontSize: 14, color: '#666'}}>共 {purchasedServices.length} 项服务</span>
                    <button className="btn-xs btn-blue" onClick={() => setShowAddPurchasedService(true)}>+ 添加购买</button>
                  </div>
                  {purchasedServices.length === 0 ? (
                    <div style={{textAlign: 'center', padding: '40px 20px', color: '#999', background: '#fafafa', borderRadius: 8}}>
                      <div style={{fontSize: 32, marginBottom: 12}}>📋</div>
                      <div style={{fontSize: 14, color: '#666'}}>暂无购买服务</div>
                    </div>
                  ) : (
                    <div style={{maxHeight: 400, overflowY: 'auto'}}>
                      {purchasedServices.map(service => {
                        const progress = service.total_times > 0 ? Math.round((service.completed_count || 0) / service.total_times * 100) : 0;
                        return (
                          <div key={service.id} style={{background: '#f5f5f5', padding: 12, borderRadius: 8, marginBottom: 10}}>
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8}}>
                              <div>
                                <div style={{fontWeight: 'bold', fontSize: 14}}>{service.service_name}</div>
                                <div style={{fontSize: 12, color: '#666'}}>{service.purchase_date} · {service.total_times}次</div>
                              </div>
                              <span style={{
                                padding: '2px 8px',
                                borderRadius: 4,
                                fontSize: 12,
                                background: service.status === 'active' ? '#e8f5e9' : service.status === 'paused' ? '#fff3e0' : '#f1f8e9',
                                color: service.status === 'active' ? '#2e7d32' : service.status === 'paused' ? '#ef6c00' : '#558b2f'
                              }}>
                                {service.status === 'active' ? '进行中' : service.status === 'paused' ? '已暂停' : '已完成'}
                              </span>
                            </div>
                            <div style={{marginBottom: 8}}>
                              <div style={{display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4}}>
                                <span>进度</span>
                                <span>{service.completed_count || 0}/{service.total_times} ({progress}%)</span>
                              </div>
                              <div style={{height: 6, background: '#e0e0e0', borderRadius: 3, overflow: 'hidden'}}>
                                <div style={{width: `${progress}%`, height: '100%', background: '#4caf50', borderRadius: 3}} />
                              </div>
                            </div>
                            <div style={{display: 'flex', gap: 8}}>
                              <button className="btn-xs btn-blue" onClick={() => { setShowServiceDetail(service); loadServiceRecords(service.id); }}>详情</button>
                              {service.status === 'active' && (
                                <button className="btn-xs btn-gray" onClick={() => updateServiceStatus(service.id, 'paused')}>暂停</button>
                              )}
                              {service.status === 'paused' && (
                                <button className="btn-xs btn-blue" onClick={() => updateServiceStatus(service.id, 'active')}>恢复</button>
                              )}
                              <button className="btn-xs btn-red" onClick={() => deletePurchasedService(service.id)}>删除</button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* 膳食管理弹窗 */}
      {showDietaryModal && (
        <DietaryManagement
          customer={selectedCustomer}
          onClose={() => setShowDietaryModal(false)}
          user={user}
        />
      )}

      {/* Toast提示组件 */}
      {toast.show && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          padding: '12px 20px',
          background: toast.type === 'success' ? '#4caf50' : '#f44336',
          color: '#fff',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 9999,
          fontSize: '14px',
          fontWeight: 500,
          transform: 'translateX(0)',
          transition: 'all 0.3s ease-out'
        }}>
          {toast.message}
        </div>
      )}

      {/* 添加购买服务弹窗 */}
      {showAddPurchasedService && (
        <div className="modal-mask" onClick={() => setShowAddPurchasedService(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-title">
              <span>添加购买服务</span>
              <span className="modal-close" onClick={() => setShowAddPurchasedService(false)}>×</span>
            </div>
            <div className="modal-content">
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">选择服务</label>
                  <select className="form-input" id="addServiceSelect">
                    <option value="">请选择服务</option>
                    {availableServices.map(s => (
                      <option key={s.id} value={s.id} data-name={s.name}>{s.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">购买日期</label>
                  <input type="date" className="form-input" id="addServiceDate" defaultValue={new Date().toISOString().split('T')[0]} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">服务次数</label>
                  <input type="number" className="form-input" id="addServiceTimes" defaultValue="10" min="1" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">备注</label>
                  <textarea className="form-input" id="addServiceNotes" placeholder="可选备注" />
                </div>
              </div>
            </div>
            <div className="modal-foot">
              <button onClick={() => setShowAddPurchasedService(false)}>取消</button>
              <button className="action-btn btn-blue" onClick={async () => {
                const select = document.getElementById('addServiceSelect');
                const serviceId = select.value;
                const serviceName = select.options[select.selectedIndex]?.dataset?.name || select.options[select.selectedIndex]?.text || '';
                const purchaseDate = document.getElementById('addServiceDate').value;
                const totalTimes = parseInt(document.getElementById('addServiceTimes').value) || 10;
                const notes = document.getElementById('addServiceNotes').value;
                if (!serviceId) { alert('请选择服务'); return; }
                try {
                  await createCustomerPurchasedService(selectedCustomer.id, {
                    service_id: parseInt(serviceId),
                    service_name: serviceName,
                    purchase_date: purchaseDate,
                    total_times: totalTimes,
                    notes
                  });
                  showToast('添加成功', 'success');
                  setShowAddPurchasedService(false);
                  loadPurchasedServices(selectedCustomer.id);
                } catch (e) {
                  showToast('添加失败', 'error');
                }
              }}>确定</button>
            </div>
          </div>
        </div>
      )}

      {/* 服务详情弹窗 */}
      {showServiceDetail && (
        <div className="modal-mask" onClick={() => setShowServiceDetail(null)}>
          <div className="modal-box modal-lg" onClick={e => e.stopPropagation()}>
            <div className="modal-title">
              <span>{showServiceDetail.service_name} - 服务详情</span>
              <span className="modal-close" onClick={() => setShowServiceDetail(null)}>×</span>
            </div>
            <div className="modal-content">
              <div style={{background: '#f9f9f9', padding: '12px', borderRadius: '8px', marginBottom: '16px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px'}}>
                  <span>总服务次数: <strong>{showServiceDetail.total_times}</strong> 次</span>
                  <span>购买日期: {showServiceDetail.purchase_date}</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span>已完成: <strong>{serviceRecords.length}</strong> 次</span>
                  <span>状态: {showServiceDetail.status === 'active' ? '进行中' : showServiceDetail.status === 'paused' ? '已暂停' : '已完成'}</span>
                </div>
              </div>
              <div className="detail-section-title">服务记录</div>
              {serviceRecords.length === 0 ? (
                <div style={{color: '#999', textAlign: 'center', padding: '20px'}}>暂无服务记录</div>
              ) : (
                <div style={{maxHeight: '300px', overflowY: 'auto'}}>
                  {serviceRecords.map(record => (
                    <div key={record.id} style={{background: '#f9f9f9', padding: '10px', borderRadius: '6px', marginBottom: '8px'}}>
                      <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                        <span>{record.record_date}</span>
                        <span style={{color: record.completion_rate >= 100 ? '#52c41a' : '#fa8c16'}}>
                          {record.completion_rate >= 100 ? '✓已完成' : '部分完成'} {record.completion_rate}%
                        </span>
                      </div>
                      <div style={{fontSize: '13px', color: '#666', marginTop: '4px'}}>{record.service_content || '-'}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="modal-foot">
              <button onClick={() => setShowServiceDetail(null)}>关闭</button>
              <button className="action-btn btn-blue" onClick={() => setShowAddServiceRecord(true)}>+ 添加记录</button>
            </div>
          </div>
        </div>
      )}

      {/* 添加服务记录弹窗 */}
      {showAddServiceRecord && (
        <div className="modal-mask" onClick={() => setShowAddServiceRecord(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-title">
              <span>添加服务记录</span>
              <span className="modal-close" onClick={() => setShowAddServiceRecord(false)}>×</span>
            </div>
            <div className="modal-content">
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">服务日期</label>
                  <input type="date" className="form-input" id="recordDate" defaultValue={new Date().toISOString().split('T')[0]} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">服务内容</label>
                  <textarea className="form-input" id="recordContent" placeholder="填写本次服务内容" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">完成度 (%)</label>
                  <input type="number" className="form-input" id="recordRate" defaultValue="100" min="0" max="100" />
                </div>
              </div>
            </div>
            <div className="modal-foot">
              <button onClick={() => setShowAddServiceRecord(false)}>取消</button>
              <button className="action-btn btn-blue" onClick={async () => {
                const recordDate = document.getElementById('recordDate').value;
                const serviceContent = document.getElementById('recordContent').value;
                const completionRate = parseInt(document.getElementById('recordRate').value) || 100;
                try {
                  await createServiceRecord(showServiceDetail.id, {
                    customer_id: selectedCustomer.id,
                    record_date: recordDate,
                    service_content: serviceContent,
                    completion_rate: completionRate
                  });
                  showToast('添加成功', 'success');
                  setShowAddServiceRecord(false);
                  loadServiceRecords(showServiceDetail.id);
                  loadPurchasedServices(selectedCustomer.id);
                } catch (e) {
                  showToast('添加失败', 'error');
                }
              }}>确定</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Customers;